
import { defineComponent } from 'vue';
import { $api } from '../common/apiService';
import { Trip } from '@/Models/Trip';
import TripTile from '@/components/TripTile.vue';

export default defineComponent({
  name: 'FutureTripsPage',
  components: { TripTile },
  data() {
    return {
      futureTrips: [] as Trip[],
    };
  },
  async mounted() {
    const trips = await $api.trips.fetch();
    if (trips) {
      const today = new Date();
      this.futureTrips = trips.filter(t => new Date(t.startDate) >= today);
    }
  },
});
